import {IWechatMerchantApplyment, WechatMerchantApplyment} from "@/model/wechat_merchant_applyment";
import {UserAgent} from "@/model/user_agent";
import {reactive} from "vue";
import {api} from "@/lib/api";

export interface IWechatMerchantBank {
    bank_alias: string;
    bank_alias_code: string;
    account_bank: string;
    account_bank_code: number;
    need_bank_branch: boolean;
}

export interface IWechatMerchantBankBranch {
    bank_branch_name: string;
    bank_branch_id: number;
}

export interface IWechatMerchantProvince {
    province_name: string;
    province_code: number;
}

export interface IWechatMerchantCity {
    province_code: number;
    city_name: string;
    city_code: number;
}


export class WechatMerchant {
    public readonly applyments: { [key: string]: WechatMerchantApplyment } = reactive({})
    private provinces: IWechatMerchantProvince[] = []
    private cities: IWechatMerchantCity[] = []

    constructor(readonly agent: UserAgent, applyments: { [key: string]: IWechatMerchantApplyment }) {
        Object.keys(applyments).forEach(key => {
            this.applyments[key] = new WechatMerchantApplyment(this, applyments[key])
        })
    }

    update(applyments: { [key: string]: IWechatMerchantApplyment }) {
        Object.keys(applyments).forEach(key => {
            this.applyments[key] = new WechatMerchantApplyment(this, applyments[key])
        })
    }

    needShowEnter(): boolean {
        return Object.values(this.applyments).length == 0 || Object.values(this.applyments).filter(i => !['APPLYMENT_STATE_FINISHED'].includes(i.applyment.state)).length > 0
    }

    applyment(id: string): WechatMerchantApplyment | undefined {
        return this.applyments[id]
    }

    async banksSearchByBankAccount(account: string): Promise<IWechatMerchantBank[]> {
        return await api({url: 'user/merchant/banks/by/bank/account', method: 'POST', data: {account}})
    }

    async banksSearch(key: string, personal: string): Promise<IWechatMerchantBank[]> {
        return await api({url: 'user/merchant/banks', params: {key, personal}})
    }

    async banksProvinces(): Promise<IWechatMerchantProvince[]> {
        if (this.provinces.length == 0) this.provinces = await api({url: 'user/merchant/provinces'})
        return this.provinces
    }

    async banksCities(): Promise<IWechatMerchantCity[]> {
        if (this.cities.length == 0) this.cities = await api({url: 'user/merchant/cities'})
        return this.cities
    }

    async banksBranches(bank_alias_code: string, city_code: string, offset: string): Promise<IWechatMerchantBankBranch[]> {
        return await api({url: 'user/merchant/banks/branches', params: {bank_alias_code, city_code, offset}})
    }

    async new(): Promise<WechatMerchantApplyment> {
        const applyment = await api<void, IWechatMerchantApplyment>({url: 'user/merchant/new'})
        this.applyments[applyment.business_code] = new WechatMerchantApplyment(this, applyment)
        return this.applyments[applyment.business_code]
    }

    available(): IWechatMerchantApplyment[] {
        return Object.values(this.applyments).filter(a => a.applyment.state == 'APPLYMENT_STATE_FINISHED').map(a => a.data())
    }

    async check(mchId:string): Promise<any> {
        return api({url:`user/merchant/${mchId}/check`})
    }

    async profitSharingRate(mchId:string): Promise<any> {
        return api({url:`user/merchant/${mchId}/profit/sharing/rate`})
    }
}